import ApplicationController from "./application_controller";
import morphdom from "morphdom";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Liste Dappel JS en cours ...");
        super.connect();
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });

            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log(
                    "From intervention_controller.js =======> ",
                    element.scrollTop
                );
                document.getElementById("scrollevel").value = element.scrollTop;
            });
        }
    }

    toggle() {
        if (this.isopened != 3) {
            this.initZindex()
            this.isopened = 3;
            this.fct($("#mySidebar").css("width") > "0px").then((res) => {
                if (res == true) {
                    this.isopened = 1;
                } else {
                    this.isopened = 0;
                }
            });
        } else {
            /*********/
        }
    }

    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }


    save_saisie_detail(event) {
        if (this.isActionCableConnectionOpen()) {
            console.log("Yes !");
            this.stimulate("ListeDappels#save_saisie_detail", event.currentTarget);
        } else {
            console.log("Oh Nooo !");
            jQuery('.child-loader').hide();
            var element = event.currentTarget;
            var id = element.dataset.appelId;
            jQuery('#icon_success_' + id).hide();
            jQuery('#icon_fail_' + id).show();
        }
    }

    beforeSaveSaisieDetail(element) {
        jQuery('.child-loader').show();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).hide();
    }

    saveSaisieDetailSuccess(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).show();
    }

    saveSaisieDetailError(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).show();
    }

    save_saisie_priorite(event) {
        if (this.isActionCableConnectionOpen()) {
            console.log("Yes !");
            this.stimulate("ListeDappels#save_saisie_priorite", event.currentTarget);
        } else {
            console.log("Oh Nooo !");
            jQuery('.child-loader').hide();
            var element = event.currentTarget;
            var id = element.dataset.appelId;
            jQuery('#icon_success_' + id).hide();
            jQuery('#icon_fail_' + id).show();
        }
    }

    beforeSaveSaisiePriorite(element) {
        jQuery('.child-loader').show();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).hide();
    }

    saveSaisiePrioriteSuccess(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        //jQuery('#icon_success_' + id).show();
    }

    afterSaveSaisiePriorite(element) {
        console.log("afterSaveSaisiePriorite");
        this.updateCalls(element);

    }

    saveSaisiePrioriteError(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).show();
    }

    save_saisie_date(event) {
        if (this.isActionCableConnectionOpen()) {
            console.log("Yes !");
            this.stimulate("ListeDappels#save_saisie_date", event.currentTarget);
        } else {
            console.log("Oh Nooo !");
            jQuery('.child-loader').hide();
            var element = event.currentTarget;
            var id = element.dataset.appelId;
            jQuery('#icon_success_' + id).hide();
            jQuery('#icon_fail_' + id).show();
        }
    }

    beforeSaveSaisieDate(element) {
        jQuery('.child-loader').show();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).hide();
    }

    saveSaisieDateSuccess(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).show();
    }

    saveSaisieDateError(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).show();
    }

    save_saisie_appel_statut_id(event) {
        if (this.isActionCableConnectionOpen()) {
            console.log("Yes !");
            this.stimulate("ListeDappels#save_saisie_appel_statut_id", event.currentTarget);
        } else {
            console.log("Oh Nooo !");
            jQuery('.child-loader').hide();
            let element = event.currentTarget;
            let id = element.dataset.appelId;
            jQuery('#icon_success_' + id).hide();
            jQuery('#icon_fail_' + id).show();
        }
    }

    beforeSaveSaisieAppelStatutId(element) {
        jQuery('.child-loader').show();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).hide();
    }

    afterSaveSaisieAppelStatutId(element) {
        console.log("afterSaveSaisieAppelStatutId");
        console.log(element);


        console.log(this.urlsolution);
        console.log(element.dataset);

        this.updateCalls(element);

    }

    smoothRemoveElement(elementId, fromTargetId ) {
        const element = document.getElementById(elementId);

        console.log('fromTargetId fromTargetId ', fromTargetId);


        if (element) {
            // Add class to start the transition
            element.classList.add("fx-smooth-remove", "fx-fade-out");

            // Set a timeout to remove the element after the transition

            setTimeout(() => {
                if (element.parentNode) {
                    element.parentNode.removeChild(element);  // Remove the element from the DOM

                    // Check if fromTargetId element exists

                    const fromTargetElement = document.getElementById(fromTargetId);
                    console.log("Le tr à delete est:", element);
                    console.log("Le statut a changer donc <><> form target est:", fromTargetId, fromTargetElement);
                    if (fromTargetElement) {
                        // IDs to check and remove if no associated <tr> exists
                        const idsToCheck = [`${fromTargetId}_1`, `${fromTargetId}_2`, `${fromTargetId}_3`];
                        let hasTrElements = false;

                        idsToCheck.forEach(id => {
                            // Check if there's any <tr> with a class matching the id
                            if (!fromTargetElement.querySelector(`tr.${id}`)) {
                                // If no <tr> with the class exists, remove the element with the id
                                const elementToRemove = document.getElementById(id);
                                if (elementToRemove && elementToRemove.parentNode) {
                                    elementToRemove.parentNode.removeChild(elementToRemove);
                                }
                            } else {
                                // If a <tr> is found, set hasTrElements to true
                                hasTrElements = true;
                            }
                        });

                        // If no <tr> elements were found, remove fromTargetElement from the DOM
                        if (!hasTrElements && fromTargetElement.parentNode) {
                            const newContent = `<div id="${fromTargetId}"></div>`;

                            morphdom(fromTargetElement, newContent);
                        }
                    }


                }
            }, 100); // Duration should match the longest transition time in CSS
        } else {
            console.log("Element not found: " + elementId);
        }
    }


// smoothRemoveElement(`call_${element.dataset.appelId}`);
    updateCalls(element) {
        const url = `${element.dataset.app}/liste_dappels/updated_calls?liste_dappel_id=${element.dataset.listeDappelId}&appel_id=${element.dataset.appelId}`;
        this.fetchCallData(url)
            .then(call_json => this.handleCallData(call_json, element))
            .catch(error => console.error('Error fetching calls:', error));
    }

    fetchCallData(url) {
        return fetch(url)
            .then(response => response.json())
            .then(call_json => {
                console.log("Json Received: ", call_json);
                return call_json;
            });
    }

    handleCallData(call_json, element) {
        const call = new Appel(call_json);
        let type = this.getType(call.appel_statut_id);
        let targetWrapper = document.getElementById(`fx_appels_${type}`);
        let targetPriorityHeader = document.getElementById(`fx_appels_${type}_${call.priorite}`);
        const didStatusChanged = type !== element.dataset.type;


        console.log("didStatusChanged est : ", didStatusChanged);
        console.log("didStatusChanged est : ", element.dataset.type, type);
        console.log(targetWrapper);
        console.log(targetPriorityHeader);
        console.log(type);
        console.log(call.getSummary());

        const hasRows = targetWrapper && targetWrapper.querySelector('tr');

        if (hasRows) {
            const partialUrl = this.buildPartialUrl(element, call_json, type, 'render_call_partial');
            this.fetchAndUpdateDom(partialUrl, targetPriorityHeader, call, targetWrapper, false,`fx_appels_${element.dataset.type}`);
        } else {
            const partialUrl = this.buildPartialUrl(element, call_json, type, 'render_calls_partial');
            this.fetchAndUpdateDom(partialUrl, targetPriorityHeader, call, targetWrapper, true,`fx_appels_${element.dataset.type}`);
        }
    }

    buildPartialUrl(element, call_json, type, partialPath) {
        const baseUrl = element.dataset.app.startsWith('http') ? element.dataset.app : `${window.location.origin}/${element.dataset.app}`;
        const partialUrl = new URL(`${baseUrl}/liste_dappels/${partialPath}`);

        partialUrl.searchParams.append('call', JSON.stringify(call_json));
        partialUrl.searchParams.append('design', element.dataset.design);
        partialUrl.searchParams.append('type', type);
        partialUrl.searchParams.append('liste_dappel_id', element.dataset.listeDappelId);

        return partialUrl;
    }

    fetchAndUpdateDom(partialUrl, targetPriorityHeader, call, targetWrapper, isNewWrapper = false,fromTargetId) {
        console.log('fetchAndUpdateDom called with parameters:', {
            partialUrl,
            targetPriorityHeader,
            call,
            targetWrapper,
            isNewWrapper,fromTargetId

        });
        let type = this.getType(call.appel_statut_id);



        console.log("LE type deans fetchAndUpdateDom est :",type);
        console.log("LE fromTargetId deans fetchAndUpdateDom est :",fromTargetId);



        console.log("LE fromTargetId deans fetchAndUpdateDom after est :",fromTargetId);

        fetch(partialUrl, {
            method: 'GET',
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        })
            .then(response => {
                console.log('Fetch response received');
                return response.text();
            })
            .then(html => {
                console.log('HTML content fetched:', html);

                // Vérification si le HTML contient l'ID 'table_saisie_au_km'
                if (html.includes('table_saisie_au_km')) {
                    console.log('HTML contains table_saisie_au_km, skipping usual instructions and appending directly to targetWrapper');
                    this.smoothRemoveElement(`call_${call.id}`, fromTargetId);
                    const targetType = this.determineTarget(html);
                    // Insérer directement le HTML dans targetWrapper
                    const newContent = `<div id="${`fx_appels_${type}`}"><br/><br/><h3>${this.getTargetTypeTranslation(`fx_appels_${type}`)}</h3>${html}</div>`;
                    morphdom(targetWrapper, newContent);
                    // targetWrapper.insertAdjacentHTML('beforeend', html);
                    console.log('HTML appended directly to targetWrapper');

                    setTimeout(() => {
                        const id = call.id;
                        console.log("HEllo  ici", id);
                        // Cache tous les éléments qui ont un ID commençant par 'icon_success_'
                        $('[id^="icon_success_"]').hide();

                        // Affiche l'élément spécifique
                        $('#icon_success_' + id).show();
                        const targetElement = $('#call_' + id).get(0);
                        targetElement.scrollIntoView({ behavior: "smooth", block: "center" });

                        // Ajouter la classe de surlignage
                        targetElement.classList.add('highlighted');

                        // Supprimer la classe de surlignage après 2,5 secondes
                        setTimeout(() => {
                            targetElement.classList.remove('highlighted');
                        }, 2500);
                    }, 200);

                } else {
                    console.log('HTML does not contain id="table_saisie_au_km", proceeding with usual instructions.');


                    console.log('Call type determined:', type);

                    if ((isNewWrapper && !targetWrapper) || (targetWrapper && !targetWrapper.querySelector('tbody'))) {
                        console.log('isNewWrapper and !targetWrapper OR targetWrapper exists but has no table');

                        if (!targetWrapper) {
                            console.log('Creating new table for targetWrapper');
                            targetWrapper = document.createElement('table');
                            targetWrapper.id = `fx_appels_${type}`;
                            targetWrapper.className = 'fx-fade-in fx-fade-in-active';
                            console.log('New targetWrapper created:', targetWrapper);
                        }

                        const headerExists = document.querySelector(`#fx_header_${type}`);
                        if (!headerExists) {
                            console.log('Creating new header for type:', type);
                            const header = document.createElement('h3');
                            header.id = `fx_header_${type}`;
                            header.textContent = `Appels ${type.charAt(0).toUpperCase() + type.slice(1)}`;
                            document.body.appendChild(header);
                            console.log('New header added to DOM:', header);
                        } else {
                            console.log('Header already exists for type:', type);
                        }

                        const tbodyExists = targetWrapper.querySelector('tbody');
                        if (!tbodyExists) {
                            console.log('Creating new tbody for targetWrapper');
                            const tbody = document.createElement('tbody');
                            targetWrapper.appendChild(tbody);
                            console.log('New tbody added to targetWrapper:', tbody);
                        } else {
                            console.log('Tbody already exists in targetWrapper');
                        }

                        if (!document.body.contains(targetWrapper)) {
                            document.body.appendChild(targetWrapper);
                            console.log('targetWrapper added to DOM:', targetWrapper);
                        } else {
                            console.log('targetWrapper already exists in the DOM');
                        }
                    }

                    console.log("Checking targetPriorityHeader:", targetPriorityHeader);

                    if (!targetPriorityHeader) {
                        console.log('targetPriorityHeader is not defined, creating or updating it.');
                        targetPriorityHeader = this.createOrUpdatePriorityHeader(call, targetWrapper.querySelector('tbody'));
                        console.log('targetPriorityHeader created or updated:', targetPriorityHeader);
                    }

                    const existingCallItem = document.getElementById(`call_${call.id}`);
                    console.log('Checking if existingCallItem exists:', existingCallItem);

                    if (existingCallItem) {
                        console.log('existingCallItem found, removing it smoothly');
                        this.smoothRemoveElement(`call_${call.id}`, fromTargetId);
                        console.log('existingCallItem removed, inserting new element after targetPriorityHeader');
                    } else {
                        console.log('existingCallItem not found, inserting new element after targetPriorityHeader');
                    }

                    // Insertion du nouvel HTML juste après targetPriorityHeader dans le même tbody
                    targetPriorityHeader.insertAdjacentHTML('afterend', html);
                    setTimeout(() => {
                        const id = call.id;
                        console.log("HEllo  ici", id);
                        // Cache tous les éléments qui ont un ID commençant par 'icon_success_'
                        $('[id^="icon_success_"]').hide();

                        // Affiche l'élément spécifique
                        $('#icon_success_' + id).show();
                        const targetElement = $('#call_' + id).get(0);
                        targetElement.scrollIntoView({ behavior: "smooth", block: "center" });

                        // Ajouter la classe de surlignage
                        targetElement.classList.add('highlighted');

                        // Supprimer la classe de surlignage après 2,5 secondes
                        setTimeout(() => {
                            targetElement.classList.remove('highlighted');
                        }, 2500);
                    }, 200);

                    console.log('fetchAndUpdateDom execution complete');
                }
            })
            .catch(error => {
                console.error('Error fetching partial:', error);
            });
    }

    createOrUpdatePriorityHeader(call, targetBody) {
        console.log("Dans le createOrUpdatePriorityHeader");
        console.log("Dans le createOrUpdatePriorityHeader call", call);
        console.log("Dans le createOrUpdatePriorityHeader targetBody", targetBody);
        const headerRow = document.createElement('tr');
        let type = this.getType(call.appel_statut_id);
        headerRow.innerHTML = `<td style='background:white;' colspan='9'> ${this.getTargetPrioryTranslation(call.priorite)}</td>`;
        headerRow.id = `fx_appels_${type}_${call.priorite}`;
        targetBody.appendChild(headerRow);

        console.log("Dans le createOrUpdatePriorityHeader headerRow", headerRow);
        return headerRow;
    }


    updateDOM(element, html) {
        const targetType = this.determineTarget(html);
        const tagetTypeTranlated = this.getTargetTypeTranslation(targetType);
        const targetElement = document.getElementById(targetType);


        if (!targetElement) {
            console.error(`No target element found with ID '${targetType}'`);
            return;
        }


        const newContent = `<div id="${targetType}"><br/><br/><h3>${tagetTypeTranlated}</h3>${html}</div>`;
        setTimeout(() => {
            morphdom(targetElement, newContent);
            const id = element.dataset.appelId;
            console.log("HEllo  ici", id);
            // Cache tous les éléments qui ont un ID commençant par 'icon_success_'
            $('[id^="icon_success_"]').hide();

            // Affiche l'élément spécifique
            $('#icon_success_' + id).show();
            $('#call_' + id).get(0).scrollIntoView({behavior: "smooth", block: "center"});
        }, 200)
    }

    determineTarget(html) {
        return html.includes('class="fx_appels_termines"') ? 'fx_appels_termines' : 'fx_appels_en_cours';
    }


    getType(typeId) {
        typeId = parseInt(typeId);

        console.log(" getType getType getType getType getType ", typeId);

        if (typeId === 1) {
            return "en_cours"
        } else if ([2, 3].includes(typeId)) {
            return "termines"
        } else {
            return "undefined"
        }

    }

    getTargetWrapper() {

        return html.includes('class="fx_appels_termines"') ? 'fx_appels_termines' : 'fx_appels_en_cours';
    }

    getTargetTypeTranslation(targetType) {
        if (targetType === "fx_appels_termines") {
            return "Appels terminées";
        } else if (targetType === "fx_appels_en_cours") {
            return "Appels en cours";
        } else {
            return "Statut inconnu";
        }

    }

    getTargetPrioryTranslation(priorityId) {
        if (priorityId === 1) {
            return "Priorité faible";
        } else if (priorityId === 3) {
            return "Priorité élevée";
        } else if (priorityId === 2) {
            return "Priorité Moyenne";
        } else {
            return "Priorité inconnue";
        }

    }


    saveSaisieAppelStatutIdSuccess(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        // jQuery('#icon_success_' + id).show();
    }

    saveSaisieAppelStatutIdError(element) {
        jQuery('.child-loader').hide();
        var id = element.dataset.appelId;
        jQuery('#icon_success_' + id).hide();
        jQuery('#icon_fail_' + id).show();
    }
}

class Appel {
    constructor({
                    id,
                    sujet,
                    date,
                    contact_id,
                    fx_user_id = null,
                    appel_type_id,
                    appel_statut_id,
                    detail,
                    contact2_id,
                    liste_dappel_id,
                    priorite,
                    piste_id = null,
                    updated_at,
                    mission_id = null,
                    created_at,
                    fx_user2_id,
                    fx_user3_id,
                    main_courante = null
                }) {
        this.id = id;
        this.sujet = sujet;
        this.date = new Date(date); // Convert to Date object
        this.contact_id = contact_id;
        this.fx_user_id = fx_user_id;
        this.appel_type_id = appel_type_id;
        this.appel_statut_id = appel_statut_id;
        this.detail = detail;
        this.contact2_id = contact2_id;
        this.liste_dappel_id = liste_dappel_id;
        this.priorite = priorite;
        this.piste_id = piste_id;
        this.updated_at = new Date(updated_at); // Convert to Date object
        this.mission_id = mission_id;
        this.created_at = new Date(created_at); // Convert to Date object
        this.fx_user2_id = fx_user2_id;
        this.fx_user3_id = fx_user3_id;
        this.main_courante = main_courante;
    }

    // Example method to display a formatted date
    getFormattedDate() {
        return this.date.toLocaleDateString(); // Adjust format as needed
    }

    // Example method to display a summary
    getSummary() {
        return `Appel ${this.id}: ${this.sujet} (${this.detail}) - Priorité: ${this.priorite}`;
    }

    // Add more methods as needed to interact with the data
}


